import { LayoutDashboard } from "lucide-react";
import type { FC } from "react";
import React from "react";

import { PageContainer } from "@react/web/app";

import { PageView } from "../shared/components/PageView.tsx";

export const Dashboard: FC = () => (
  <PageContainer>
    <PageView
      icon={<LayoutDashboard />}
      subtitle="Welcome to AptBlocks."
      title="Dashboard"
    />
  </PageContainer>
);
